import React from 'react';
import type { VariantPicker } from '../../useSeller';

/**
 * Focuses the variant the picker opens on (`VariantPicker.initialVariantId`,
 * bos-seller#53) once it opens; the caller attaches the returned ref to that
 * option. Deferred to the next macrotask, like `VoidConfirmDialog`'s Confirm,
 * so it lands after react-aria's own dialog focus for the same render. It
 * runs once per opening (keyed on the open product), so a catalog refresh
 * while the seller is choosing never pulls focus back.
 */
export const useVariantPickerFocus = (
    picker: VariantPicker | null,
): React.RefObject<HTMLDivElement | null> => {
    const initialOptionRef = React.useRef<HTMLDivElement>(null);
    const openProductId = picker?.product.id ?? null;

    React.useEffect(() => {
        if (openProductId === null) {
            return;
        }
        const timeout = setTimeout(() => initialOptionRef.current?.focus(), 0);
        return () => clearTimeout(timeout);
    }, [openProductId]);

    return initialOptionRef;
};
